import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        application: '<',
        fields: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ vm.application.course.activeI18n.name }}
            &nbsp;
            <small>
                {{ vm.COURSE_APPLICATION_STATUS_ENUM.LABELS[vm.application.status] }},&nbsp;
                {{ vm.ApplicationService.isAddedToOccurrence(vm.application, false) }}
            </small>
            </h1>
            <a ui-sref="authorized.courses.application.list()" class="btn discrete">{{ 'general.Back to list' | translate }}</a>
        </div>
        <div class="well color01 ng-scope">
            <div class="form readonly">
                <div class="row">
                    <span class="label">{{ 'application.Applicant' | translate }}</span>
                    <div class="items"><span class="text">{{ vm.application.employee.displayName }}</span></div>
                </div>
                <div class="row">
                    <span class="label">{{ 'application.Course' | translate }}</span>
                    <div class="items"><span class="text">{{ vm.application.course.activeI18n.name }}</span></div>
                </div>
                <div class="row">
                    <span class="label">{{ 'course.Field' | translate }}</span>
                    <div class="items"><span class="text">{{ vm.CourseService.getFieldNames(vm.application.course, vm.fields) }}</span></div>
                </div>
                <div class="row">
                    <span class="label">{{ 'course.Course description' | translate }}</span>
                    <div class="items">
                        <span ng-bind-html="vm.application.course.activeI18n.description" class="text"></span>
                    </div>
                </div>
                <div class="row">
                    <span class="label">{{ 'course.Explanation' | translate }}</span>
                    <div class="items">
                        <span ng-bind-html="vm.StringService.changeNewLineToBr(vm.application.explanation)" class="text">
                        </span>
                    </div>
            </div>
            <ul class="actions01">
                <li class="primary" ng-if="vm.application.status !== vm.COURSE_APPLICATION_STATUS_ENUM.KEYS.APPROVED">
                    <a ng-click="vm.setApplicationStatus(vm.COURSE_APPLICATION_STATUS_ENUM.KEYS.APPROVED)" class="btn main">{{ 'application.Approve' | translate }}</a>
                </li>
                <li class="primary"  ng-if="vm.application.status !== vm.COURSE_APPLICATION_STATUS_ENUM.KEYS.DECLINED">
                    <a ng-click="vm.setApplicationStatus(vm.COURSE_APPLICATION_STATUS_ENUM.KEYS.DECLINED)" class="btn negative">{{ 'application.Decline' | translate }}</a>
                </li>
                <li class="primary"  ng-if="vm.application.status === vm.COURSE_APPLICATION_STATUS_ENUM.KEYS.APPROVED
                || vm.application.status === vm.COURSE_APPLICATION_STATUS_ENUM.KEYS.DECLINED">
                    <a ui-sref="authorized.courses.courses.edit.occurrence.edit.schedule({ id: vm.application.courseId, occurrenceId: vm.application.occurrenceId })" class="btn bordered02">
                        {{ 'application.Manage occurrence' | translate }}
                    </a>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($state, $translate, toastr, FormFactory, COURSE_APPLICATION_STATUS_ENUM,
                 CourseService, ApplicationService, StringService) {
        this.$state = $state;
        this.$translate = $translate;
        this.toastr = toastr;
        this.FormFactory = FormFactory;
        this.COURSE_APPLICATION_STATUS_ENUM = COURSE_APPLICATION_STATUS_ENUM;
        this.CourseService = CourseService;
        this.ApplicationService = ApplicationService;
        this.StringService = StringService;
    }

    $onInit () {
        this.form = this.FormFactory.create(this.application, (model) => model.$update({ id: this.application.id }));
    }

    setApplicationStatus (status) {
        this.form.model.status = status;
        this.form.save().then(() => {
            if (this.form.model.status === this.COURSE_APPLICATION_STATUS_ENUM.KEYS.APPROVED) {
                this.toastr.success(
                    this.$translate.instant('application.Applicants { applicantName } application successfully confirmed! Applicant added to occurrence successfully', {
                        applicantName: this.application.employee.displayName
                    })
                );
            }
            else if (this.form.model.status === this.COURSE_APPLICATION_STATUS_ENUM.KEYS.DECLINED) {
                this.toastr.success(
                    this.$translate.instant('application.Applicants { applicantName } application successfully declined. Applicant has been notified via e-mail about the declination', {
                        applicantName: this.application.employee.displayName
                    })
                );
            }
            window.location.reload(true);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/application/detail/index.js